import React from 'react';
import { Section, SectionHeader } from '../../../../components/shared/Section';
import { MetricsGrid } from '../../../../components/shared/MetricDisplay';
import type { MetricProps } from '../../../../components/shared/MetricDisplay/types';
import { cn } from '../../../../lib/utils';
import { getThemeClass } from '../../../../lib/theme';

const MetricsSection = () => {
  const metricsGroups = [
    {
      title: "Global Infrastructure Scale",
      accent: "primary" as const,
      metrics: [
        {
          value: "292,600",
          unit: "+",
          label: "Sites",
          description: "Enterprise infrastructure worldwide",
          accent: "primary"
        },
        {
          value: "226",
          unit: "+",
          label: "Countries",
          description: "Global content delivery reach",
          accent: "primary"
        },
        {
          value: "10B",
          unit: "+",
          label: "Requests",
          description: "Biweekly edge computing operations",
          accent: "primary"
        }
      ] satisfies MetricProps[]
    },
    {
      title: "Performance & Scale",
      accent: "primary" as const,
      metrics: [
        {
          value: "4M",
          unit: "requests/10min",
          label: "Load Capacity",
          description: "13x production load handled",
          accent: "primary"
        },
        {
          value: "24K",
          unit: "users",
          label: "Concurrent Users",
          description: "While maintaining performance",
          accent: "primary"
        },
        {
          value: "13x",
          unit: "",
          label: "Production Load",
          description: "Validated for global scale",
          accent: "primary"
        }
      ] satisfies MetricProps[]
    },
    {
      title: "Technical Innovation",
      accent: "secondary" as const,
      metrics: [
        {
          value: "80",
          unit: "%",
          label: "Bandwidth Reduction",
          description: "Optimized image delivery",
          accent: "secondary"
        },
        {
          value: "15min",
          unit: "to 5ms",
          label: "Indexing Latency",
          description: "Event processing architecture",
          accent: "secondary"
        }
      ] satisfies MetricProps[]
    },
    {
      title: "Business Impact",
      accent: "success" as const,
      metrics: [
        {
          value: "200",
          unit: "K+",
          label: "Cost Savings",
          description: "Infrastructure optimization",
          accent: "success"
        },
        {
          value: "42",
          unit: "%",
          label: "Cost Reduction",
          description: "Through pipeline improvements",
          accent: "success"
        },
        {
          value: "88",
          unit: "%",
          label: "Throughput Gain",
          description: "Ingestion pipeline optimization",
          accent: "success"
        }
      ] satisfies MetricProps[]
    }
  ];

  return (
    <Section background="light" spacing="sm" withDivider={true}>
      <SectionHeader
        title="Impact Through Innovation"
        subtitle="Driving measurable improvements across performance, scalability, and business efficiency through technical innovation"
        align="center"
        className={cn('mb-16', getThemeClass('colors.text.primary'))}
      />

      <div className="space-y-24 mb-10">
        {metricsGroups.map((group, index) => (
          <div key={index}>
            <h3 className={cn(
              'text-2xl font-bold mb-10 text-center',
              getThemeClass(`colors.${group.accent}.main`)
            )}>
              {group.title}
            </h3>
            <MetricsGrid
              metrics={group.metrics}
              columns={3}
              spacing="md"
              variant="light"
            />
          </div>
        ))}
      </div>
    </Section>
  );
};

export default MetricsSection;
